import type { ReactNode } from 'react';
import { toast as sonnerToast, type ExternalToast } from 'sonner';
import { openErrorReport, reportError } from '@/lib/errorReport';
import { isCustomerFacingPath } from '@/lib/marker';

type ErrorToastOptions = ExternalToast & {
  /** De opgevangen fout. De toast toont dan de oorzaak en een knop naar alle details. */
  error?: unknown;
};

function error(message: ReactNode, { error: cause, ...options }: ErrorToastOptions = {}) {
  // Klanten krijgen alleen de melding; de details zijn voor het team.
  if (cause === undefined || isCustomerFacingPath()) return sonnerToast.error(message, options);
  const report = reportError(typeof message === 'string' ? message : 'Er ging iets mis', cause);
  return sonnerToast.error(message, {
    description: report.cause === message ? report.code : `${report.cause} · ${report.code}`,
    duration: 15_000,
    action: { label: 'Details', onClick: () => openErrorReport(report.code) },
    ...options,
  });
}

/** De toast van sonner; `toast.error(melding, { error })` laat ook zien wat er misging. */
export const toast = Object.assign(
  (...args: Parameters<typeof sonnerToast>) => sonnerToast(...args),
  { ...sonnerToast, error }
);
